import axios from "axios"
import {Storage} from "@/services/Storage";
import Swal from "sweetalert2";

export default {
    name: 'backOffice',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        /**
         * Open the Online BackOffice for the current store via a
         * session-id deeplink.
         *
         * <p>Replaces the legacy `?auth=<base64-payload>` URL which
         * carried the user's plaintext password across the OS-level
         * protocol boundary. The sessionId is opaque (256-bit
         * SecureRandom) and minted at login time by
         * `POST /posAuth/{DB}/login` on Franchise V2. The receiving
         * app hydrates the user via `GET /posAuth/{DB}/session/{id}`.
         *
         * <p>On backend / network failure we deliberately open the
         * bare BackOffice URL (without `?auth=`) so the user can
         * still sign in manually rather than silently reintroducing
         * the password-bearing path.
         *
         * @param context
         * @param {{name: string}} [page] target BackOffice route; defaults to `stock`
         */
        openOnlineBackOffice : async (context, page = { name : `stock` }) => {
            try {
                const store = await Storage.getDefaultStore();
                if (!store || !store.StoreDB) {
                    throw new Error('No default store configured');
                }
                const session = await Storage.getCurrentSession(store.StoreDB);
                if (!session || !session.sessionId) {
                    throw new Error('No deeplink session for this store');
                }
                const pageName = (page && page.name) || 'stock';
                // sessionId is opaque; the receiver fetches
                // user / store details itself. The plaintext
                // password NEVER leaves this process.
                const url = `${backOfficePlatform}?session=${encodeURIComponent(session.sessionId)}`
                          + `&store=${encodeURIComponent(store.StoreDB)}`
                          + `&page=${encodeURIComponent(pageName)}`;
                // eslint-disable-next-line no-console
                console.log('[deeplink][openOnlineBackOffice] opening session URL', {
                    store: store.StoreDB,
                    page: pageName,
                    sessionIdPrefix: session.sessionId.slice(0, 8) + '...'
                });
                return openUrl(url);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('[deeplink][openOnlineBackOffice] session open failed - opening bare URL', e);
                Swal.fire({
                    icon: 'error',
                    title: 'Cannot open BackOffice',
                    text: 'Connection to server failed. Please open BackOffice manually.',
                });
                return openUrl(backOfficePlatform);
            }
        },
        searchExpenseAccounts: async (context, accountName) => {
            let store = await Storage.getDefaultStore();
            return axios.get(backOfficeTomcatApi + `chartOfAccounts/${store.StoreDB}/searchExpenseAccounts?accountName=` + accountName)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err));
        },
        capturePayout: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            let user = await Storage.getCurrentUser();
            let pcName = await Device.getPCName();

            payload.User = user.Username;
            payload.PC = pcName;
            return axios.post(backOfficeTomcatApi + `Payments/${store.StoreDB}/storePayout`, payload)
                .then(({data}) => data).catch(err => errorHandler.tomcatError(err));
        },
    },
}
